export default function bodyClasses () {
    const body = document.body;
    const mobile = 640;
    const tablet = 1023;
    const desktop = 1440;

    const updateBodyClass = () => {
        const width = window.innerWidth;
        const removeClasses = ['breakpoint-mobile', 'breakpoint-tablet', 'breakpoint-desktop', 'breakpoint-HD'];

        body.classList.remove(...removeClasses);

        if (width < mobile) {
            body.classList.add('breakpoint-mobile');
        } else if (width <= tablet) {
            body.classList.add('breakpoint-tablet');
        } else if (width < desktop) {
            body.classList.add('breakpoint-desktop');
        } else {
            body.classList.add('breakpoint-HD');
        }
    };

    updateBodyClass();
    window.addEventListener('resize', updateBodyClass);
}
